<template>
  <div class="pop">
    <div class="bg-in" :style="{backgroundImage:'url('+require('../../assets/images/account/upiPopBk.png')+')'}">
      <div class="fontGroup">
        <img :src="howUseUpi" alt=""/>
      </div>
      <div class="fontWatch">
        <p>{{ $t('lang.upiPop.watch')[0] }}</p>
        <p>{{ $t('lang.upiPop.watch')[1] }}</p>
      </div>
      <div class="goButton" @click="goToUpiTeaching">
        <img v-if="lang === 'EN'" :src="clickhere" @click="close" class="goButtonImg" alt="goButton"/>
        <img v-else :src="clickhereIN" @click="close" class="goButtonImgIN" alt="goButton"/>
      </div>
      <div class="cancel-btn">
        <img :src="cancelWhite" @click="close" alt="cancel"/>
      </div>
    </div>
  </div>
</template>

<script>
import howUseUpiEN from '@/assets/images/upiTeaching/howUseUpiEN.png'
import howUseUpiIN from '@/assets/images/upiTeaching/howUseUpiIN.png'
import cancelWhite from '@/assets/images/account/closeUpiPop.svg'
import clickhere from '@/assets/images/upiTeaching/Clickhere.png'
import clickhereIN from '@/assets/images/upiTeaching/ClickhereIN.png'
export default {
  name: 'upiPop',
  props: ['handleClose', 'goToUpiTeaching'],
  data () {
    return {
      clickhere,
      clickhereIN,
      lang: localStorage.getItem('locale'),
      howUseUpi: '',
      howUseUpiEN,
      howUseUpiIN,
      cancelWhite,
      userInfo: JSON.parse(localStorage.getItem('userInfo'))
    }
  },
  watch: {
    '$store.state.locale': function (to) {
      if (to === 'EN') {
        this.howUseUpi = howUseUpiEN
      } else {
        this.howUseUpi = howUseUpiIN
      }
    }
  },
  mounted () {
    if (this.$store.state.locale === 'EN') {
      this.howUseUpi = howUseUpiEN
    } else {
      this.howUseUpi = howUseUpiIN
    }
  },
  methods: {
    close () {
      this.handleClose()
    }
  }
}
</script>

<style lang="less" scoped>
.pop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.8);
  overflow-x: hidden;
  overflow-y: auto;
  z-index: 999;

  .bg-in {
    position: relative;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100% 100%;
    width: 100vw;
    height: 111.805vw;

    .fontGroup {
      position: absolute;
      left: 51.8%;
      transform: translate(-50%);
      top: -30vw;
      text-transform: uppercase;
      height: 53.333vw;

      img {
        width: auto;
        height: 39.30vw;
      }
    }

    .fontWatch {
      position: absolute;
      bottom: 23.75vw;
      height: 9.3vw;
      line-height: 9.3vw;
      border-radius: 5vw;
      width: 100vw;
      transform: rotate(3.5deg);
      text-shadow: -0.4vw -0.4vw 0 #ffffff,
        0.4vw -0.4vw 0 #ffffff,
      -0.4vw 0.4vw 0 #ffffff,
      0.4vw 0.4vw 0 #ffffff;
      top: 77vw;
      p {
        position: relative;
        left: 51.2%;
        transform: translate(-50%);
        text-transform: uppercase;
        color: #000000;
        font-size: 7.5vw;
        line-height: calc(7.5vw + 2px);
        font-weight: 900;
        text-align: center;
        letter-spacing: -0.03em;
        width: 54vw;
      }
    }

    .goButton {
      position: absolute;
      left: 10.5vw;
      bottom: 3.5vw;
      width: 78.75vw;
      height: 12.5vw;
      line-height: 12.5vw;
      font-size: 6.111vw;
      font-weight: 900;
      text-align: center;
      border-radius: 5vw;
      text-transform: uppercase;
      color: #FFFFFF;
      .goButtonImg{

      }
      .goButtonImgIN{
        position: relative;
        top: 1vw;
      }
    }

    .cancel-btn {
      position: absolute;
      bottom: -18vw;
      width: 100%;
      height: 3.888vw;
      margin: 7.5vw auto;
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        height: 100%;
        width: auto;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/UpiActivityPop/index.vue